export const paths = {
  LOGOUT: 'logout',
  RECOVERY: 'recovery',
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up',
  WELCOME: 'welcome',
  PASSWORD_RESET: 'password-reset',
  DELETE: 'delete',
  SUCCESS: 'success',
  EXPIRED: 'expired',
  ERROR: 'error',
  VERIFY: 'verify',
  SOCIAL: 'social',
}
